<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Distribuidor" subTitle="Editar" />

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">Informações do distribuidor</h6>
          </div>
          <!-- Content -->
          <div class="p-4">
            <distributor-form ref="distributorForm" />
          </div>
        </d-card>
      </d-col>
      <d-col lg="3" md="12">
        <sidebar-actions
          :model="distributor"
          @save="save"
          @blockAccess="blockAccess"
        />
      </d-col>
    </d-row>
    <distributor-imports />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import DistributorActions from '../components/DistributorActions';
import DistributorForm from '../components/DistributorForm.vue';
import SidebarActions from '../components/SidebarActions.vue';
import DistributorImports from '../components/DistributorImports.vue';
import {
  MODEL,
  _LOAD_MODEL_,
  _DELETE_DISTRIBUTOR_,
} from '../components/DistributorModel';

export default {
  name: 'admin-distributor-edit',
  mixins: [DistributorActions],
  components: {
    PageHeader,
    DistributorForm,
    SidebarActions,
    DistributorImports,
  },
  data() {
    return {};
  },
  computed: {
    distributor() {
      const { distributor } = this.$store.state.distributor;
      if (distributor) {
        Events.$emit(_LOAD_MODEL_, distributor);
        return distributor;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions(['setToggle', 'checkAdmin', 'getDistributor']),
    getDistributorModel(id) {
      this.setToggle({ type: 'progress', bool: true });
      this.getDistributor(id)
        .then(response => {
          Events.$emit(_LOAD_MODEL_, response);
          this.setToggle({ type: 'progress', bool: false });
        })
        .catch(error => {
          this.activeAlert({ message: error, theme: 'danger' });
        });
    },
    save() {
      this.$refs.distributorForm.save();
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$on(_DELETE_DISTRIBUTOR_, distributor => {
      this.selectDistributor = distributor.id;
    });
    if (this.$route.params.id) {
      return this.getDistributorModel(parseInt(this.$route.params.id, Number));
    }
    return this.getDistributorModel(null);
  },
  destroyed() {
    Events.$off(_DELETE_DISTRIBUTOR_);
  },
};
</script>
